import { Link } from '@/navigation'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

interface ISearchItem {
  name: string
  title: string
  short_desc?: string
  image?: string
  slug: string
  category: { id: number; name: string; slug: string }
}

const SearchItem = ({ name, title, short_desc, slug, category, image }: ISearchItem) => {
  const t = useTranslations('Buttons')

  return (
    <div className="flex flex-row justify-between gap-6 rounded-xl border border-secondary-light bg-white px-6 py-4">
      <div className="flex flex-1 flex-col">
        <div className="mb-4">
          <span className="rounded-md border border-secondary-light px-[10px] py-[6px] text-xs">
            {category.name}
          </span>
        </div>
        <h5 className=" mb-2 line-clamp-1">{name ?? title}</h5>
        <div className="flex-1">
          {short_desc && (
            <p className="mb-4 line-clamp-2 whitespace-pre-line break-words break-all">
              {short_desc}
            </p>
          )}
        </div>
        <Link className="btn-primary-outlined w-fit" href={`/${category.slug}/${slug}`}>
          {t('More')}
        </Link>
      </div>
      <div className="h-[200px] w-full max-w-[200px] overflow-hidden rounded-xl bg-primary-light text-center">
        {image ? (
          <Image
            alt="item image"
            src={image}
            width={500}
            height={500}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-[32px] text-primary/40">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 22 22"
              fill="none"
            >
              <circle
                cx="6.5"
                cy="6.5"
                r="1.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.5 11C1.5 6.52166 1.5 4.28249 2.89124 2.89124C4.28249 1.5 6.52166 1.5 11 1.5C15.4783 1.5 17.7175 1.5 19.1088 2.89124C20.5 4.28249 20.5 6.52166 20.5 11C20.5 15.4783 20.5 17.7175 19.1088 19.1088C17.7175 20.5 15.4783 20.5 11 20.5C6.52166 20.5 4.28249 20.5 2.89124 19.1088C1.5 17.7175 1.5 15.4783 1.5 11Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                d="M4 19.9999C8.37246 14.775 13.2741 7.884 20.4975 12.5424"
                stroke="currentColor"
                strokeWidth="1.5"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  )
}

export default SearchItem
